import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const CloseIcon = ({
  title = 'Close',
  viewBox = '0 0 20 18',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M18.57.57a1.5 1.5 0 01.06 2.057l-.06.064-6.449 6.448 6.28 6.28a1.5 1.5 0 01-2.057 2.182l-.064-.06L10 11.26l-6.28 6.28a1.5 1.5 0 01-2.181-2.058l.06-.064 6.28-6.28L1.43 2.69A1.5 1.5 0 013.488.509l.064.06L10 7.019 16.448.57a1.5 1.5 0 012.122 0z" />
  </CreateIconComponent>
);

export default CloseIcon;
